import React, { useEffect, useState } from "react"
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Table,
} from "reactstrap"
import plusIcon from "../../assets/icons/plusIcon.svg"
import minusIcon from "../../assets/icons/minusIcon.svg"
import NumberFormat from "../../utils/numberFormat"
import UpdateTable from "./UpdatedTable"
import arrow from "../../assets/icons/arrow.svg"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { setFilter } from "../../store/actions"

const NestedAccordion = ({
  data = [],
  parentKey = "root",
  startDate,
  endDate,
  menuLabels,
  onOpenChange,
  forceOpenAll = false,
}) => {
  const [open, setOpen] = useState([])
  const dispatch = useDispatch()

  // const toggle = id => {
  //   // setOpen(open === id ? "" : id)
  //   const newOpen = open === id ? "" : id
  //   setOpen(newOpen)
  //   if (typeof onOpenChange === "function") onOpenChange(newOpen)
  // }

  // Line ~36: notify parent with source key and open ids
  // Replace the previous notifyParent with this (near top of file)
  const notifyParent = openArray => {
    console.log(`openArray`, openArray)

    if (typeof onOpenChange !== "function") return
    try {
      // If parent expects two args, pass (parentKey, openArray),
      // otherwise fall back to single-arg for backward compatibility.
      if (onOpenChange.length >= 2) {
        onOpenChange(parentKey, openArray)
      } else {
        onOpenChange(openArray)
      }
    } catch (err) {
      try {
        onOpenChange(openArray)
      } catch (e) {
        // swallow - don't break UI
      }
    }
  }

  // collect every data.id inside this subtree (recursive)
  const collectAllIds = arr => {
    const ids = []
    const walk = items => {
      items?.forEach(it => {
        if (it?.id != null) ids.push(String(it.id))
        if (it?.sub_groups?.length) walk(it.sub_groups)
      })
    }
    walk(arr)
    return ids
  }

  useEffect(() => {
    if (forceOpenAll) {
      const ids = collectAllIds(data)
      setOpen(ids)
      notifyParent(ids)
    } else {
      // if previously forced open, then collapse when false
      // (optional: keep existing open state if you prefer)
      setOpen([])
      notifyParent([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceOpenAll, data])

  // toggle by data id (accepts number or string)
  const toggle = id => {
    if (forceOpenAll) return
    const idStr = String(id)
    const exists = open.includes(idStr)
    const newOpen = exists ? open.filter(x => x !== idStr) : [...open, idStr]
    setOpen(newOpen)
    notifyParent(newOpen)
  }

  // notify parent on mount and whenever open changes
  useEffect(() => {
    notifyParent(open)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  console.log(`Accordion open:`, open)

  // useEffect(() => {
  //   if (typeof onOpenChange === "function") onOpenChange(open)
  // }, [open, onOpenChange])
  const navigate = useNavigate()

  const desimalrange = localStorage.getItem("desimalrange")

  const assetColumns = [
    {
      label: "Group Name",
      renderCell: item => (
        <div
          onClick={() => {
            navigate(`/finance-ledger-acc`, {
              state: { item, startDate, endDate, menuLabels },
            })
            dispatch(setFilter({ dateFrom: startDate, dateTo: endDate }))
          }}
          className="pointer fw-bold ps-3"
        >
          {item?.ledger_name}
          <span className="ps-1">
            <img src={arrow} alt="" width="7" />
          </span>
        </div>
      ),
    },
    {
      label: "",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.debit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.debit) > Number(item?.credit)
                    ? Number(item?.debit) - Number(item?.credit)
                    : 0
                ),
                desimalrange || 2,
                desimalrange || 2
              )}`
            : "-"}
        </div>
      ),
    },
    {
      label: "",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.credit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.credit) > Number(item?.debit)
                    ? Number(item?.credit) - Number(item?.debit)
                    : 0
                ),
                desimalrange || 2,
                desimalrange || 2
              )}`
            : "-"}
        </div>
      ),
    },
  ]

  return (
    <Accordion open={open} toggle={toggle}>
      {data?.map((item, index) => {
        const currentKey =
          item?.id != null ? String(item.id) : `${parentKey}-${index}`
        // const isOpen = open === currentKey
        const isOpen = open.includes(currentKey)

        return (
          <AccordionItem key={item?.id || currentKey}>
            <AccordionHeader
              targetId={currentKey}
              className="d-flex align-items-center w-100 pointer custom-header-accordion py-0"
              style={{
                pointerEvents: forceOpenAll ? "none" : "auto",
                cursor: forceOpenAll ? "not-allowed" : "pointer",
              }}
              // className="d-flex align-items-center w-100 pointer custom-header-accordion py-0"
            >
              {/* Column 1: Icon + Group Name */}
              <div className="w-50 d-flex align-items-center">
                <img
                  src={isOpen ? minusIcon : plusIcon}
                  alt={isOpen ? "Collapse" : "Expand"}
                  style={{ width: "8px", height: "8px", marginRight: "4px" }}
                />
                {item.group_name}
              </div>

              {/* Column 2: Debit */}
              <div className="w-25 pe-5 text-end">
                {item?.debit
                  ? `${NumberFormat(
                      Math.abs(
                        Number(item?.debit) > Number(item?.credit)
                          ? Number(item?.debit) - Number(item?.credit)
                          : 0
                      ),
                      desimalrange,
                      desimalrange
                    )}`
                  : "-"}
              </div>

              {/* Column 3: Credit */}
              <div className="w-25 pe-5 text-end">
                {item?.credit
                  ? `${NumberFormat(
                      Math.abs(
                        Number(item?.credit) > Number(item?.debit)
                          ? Number(item?.credit) - Number(item?.debit)
                          : 0
                      ),
                      desimalrange,
                      desimalrange
                    )}`
                  : "-"}
              </div>
            </AccordionHeader>

            <AccordionBody accordionId={currentKey} className="py-0">
              {/* Ledgers Table */}
              {item.ledgers?.length > 0 && (
                <UpdateTable
                  //   className="mt-2"
                  nodes={item.ledgers}
                  columns={assetColumns}
                  handilpagedrop={false}
                  tableWidth="50% 25% 25%"
                  mobileWidth="50% 25% 25%"
                  headerHide={true}
                />
              )}

              {/* Recursive sub-groups */}
              {item.sub_groups?.length > 0 && (
                <NestedAccordion
                  data={item?.sub_groups}
                  parentKey={currentKey}
                  onOpenChange={onOpenChange}
                  forceOpenAll={forceOpenAll}
                />
              )}
            </AccordionBody>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default NestedAccordion
